import React, { PropsWithChildren } from 'react';
import { withTheme } from '@material-ui/core';

import { Theme } from '../../types/common.types';

import './style.css';

const MenuItem: React.FC<PropsWithChildren<{ theme: Theme }>> = ({ children, theme, ...props }) => (
  <li className="menu__item" style={{ color: theme.palette.text.primary }} {...props}>
    {children}
  </li>
);

// @ts-ignore
const Themed = withTheme(MenuItem);

export { Themed as MenuItem };
